export default "__VITE_ASSET__CAu_rdlU__"